module.exports = __webpack_public_path__ + "img/yuken-takigaura.6393b2c5.png";